import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
} from '@angular/core';

import { Icono, NombreIcono } from '../icono/icono';

/** Tono del aviso. Son las tres variantes del componente `alert` del Figma. */
export type TipoAlerta = 'error' | 'exito' | 'advertencia';

/** Glifo de cada tono (`Toast-*.svg` del catálogo, igual que el backoffice). */
const ICONO: Record<TipoAlerta, NombreIcono> = {
  error: 'toast-error',
  exito: 'toast-success',
  advertencia: 'toast-warning',
};

/**
 * Aviso en línea con icono, título y texto. Portado de `AlertComponent` del
 * backoffice (`src/components/alert/`), adaptado a signals.
 *
 * A diferencia del backoffice, el icono va inline por `app-icono` en vez de un
 * `<img>` recoloreado con filtros: el color sale del CSS del contenedor, que es
 * cómo se pintan los iconos en el portal.
 *
 * Es el único canal para los errores generales del portal: el backoffice usa
 * toasts para eso y acá no hay pila de toasts (ver `core/errores-backend.ts`).
 */
@Component({
  selector: 'app-alerta',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [Icono],
  templateUrl: './alerta.html',
  styleUrl: './alerta.scss',
  host: {
    '[class]': '"alerta alerta--" + tipo()',
    role: 'alert',
  },
})
export class Alerta {
  readonly tipo = input.required<TipoAlerta>();
  readonly titulo = input<string>();
  readonly mensaje = input.required<string>();

  readonly cerrada = output<void>();

  protected readonly icono = computed(() => ICONO[this.tipo()]);
}
